<template>
  <el-dialog
    :title="$t('common.confirm')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align:center">
      <p>{{ $t('affiliateUser.confirmDeleteAffiliateUser') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{ $t('common.confirmDelete') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteAffiliateUser } from '@/api/affiliate/affiliateUserApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteAffiliateUser',
  data() {
    return {
      dialogVisible: false,
      formData: {
        auId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(data) {
      this.resetForm()
      this.formData.auId = data.auId
      this.formData.shopId = getShopId()
      this.dialogVisible = true
    },
    resetForm() {
      this.formData = {
        auId: '',
        shopId: ''
      }
    },
    handleClose() {
      this.resetForm()
    },
    async handleConfirm() {
      try {
        await deleteAffiliateUser(this.formData)
        this.$message.success(this.$t('common.operateSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除分销员失败:', error)
      }
    }
  }
}
</script>